webpackJsonp([2],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _LoadingButton = __webpack_require__(43);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  LoadingButton: {
	    displayName: 'LoadingButton'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Loader/LoadingButton.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var LoadingButton = _wrapComponent('LoadingButton')((_dec = (0, _reactCssModules2.default)(_LoadingButton2.default), _dec(_class = function (_Component) {
	  (0, _inherits3.default)(LoadingButton, _Component);
	
	  function LoadingButton() {
	    (0, _classCallCheck3.default)(this, LoadingButton);
	    return (0, _possibleConstructorReturn3.default)(this, (LoadingButton.__proto__ || (0, _getPrototypeOf2.default)(LoadingButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoadingButton, [{
	    key: 'render',
	
	    // static propTypes = {
	    //   color: PropTypes.string,
	    //   text: PropTypes.string,
	    //   style: PropTypes.object,
	    // };
	    // static defaultProps = {
	    //   color: 'orange',
	    // };
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'sk-folding-cube' },
	        _react3.default.createElement('div', { styleName: 'sk-cube' }),
	        _react3.default.createElement('div', { styleName: 'sk-cube2' }),
	        _react3.default.createElement('div', { styleName: 'sk-cube4' }),
	        _react3.default.createElement('div', { styleName: 'sk-cube3' })
	      );
	    }
	  }]);
	  return LoadingButton;
	}(_react2.Component)) || _class));
	
	exports.default = LoadingButton;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(57);
	
	var animateScroll = __webpack_require__(50);
	var scrollSpy = __webpack_require__(68);
	var defaultScroller = __webpack_require__(69);
	var assign = __webpack_require__(28);
	
	
	var protoTypes = {
	  to: React.PropTypes.string.isRequired,
	  containerId: React.PropTypes.string,
	  activeClass:React.PropTypes.string,
	  spy: React.PropTypes.bool,
	  smooth: React.PropTypes.bool,
	  offset: React.PropTypes.number,
	  delay: React.PropTypes.number,
	  isDynamic: React.PropTypes.bool,
	  onClick: React.PropTypes.func,
	  duration: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.func]),
	  absolute: React.PropTypes.bool,
	  onSetActive: React.PropTypes.func
	};
	
	var Helpers = {
	
	  Scroll: function (Component, customScroller) {
	
	    var scroller = customScroller || defaultScroller;
	
	    return React.createClass({
	
	      propTypes: protoTypes,
	
	      getDefaultProps: function() {
	        return {offset: 0};
	      },
	
	      scrollTo : function(to, props) {
	          scroller.scrollTo(to, props);
	      },
	
	      handleClick: function(event) {
	
	        /*
	         * give the posibility to override onClick
	         */
	
	        if(this.props.onClick) {
	          this.props.onClick(event);
	        }
	
	        /*
	         * dont bubble the navigation
	         */
	
	        if (event.stopPropagation) event.stopPropagation();
	        if (event.preventDefault) event.preventDefault();
	
	        /*
	         * do the magic!
	         */
	        this.scrollTo(this.props.to, this.props);
	
	      },
	
	      spyHandler: function(y) {
	        var element = scroller.get(this.props.to);
	        if (!element) return;
	        var cords = element.getBoundingClientRect();
	        var topBound = cords.top + y;
	        var bottomBound = topBound + cords.height;
	        var offsetY = y - this.props.offset;
	        var to = this.props.to;
	        var isInside = (offsetY >= topBound && offsetY <= bottomBound);
	        var isOutside = (offsetY < topBound || offsetY > bottomBound);
	        var activeLink = scroller.getActiveLink();
	
	        if (isOutside && activeLink === to) {
	          scroller.setActiveLink(void 0);
	          this.setState({ active : false });
	
	        } else if (isInside && activeLink != to) {
	          scroller.setActiveLink(to);
	          this.setState({ active : true });
	
	          if(this.props.onSetActive) {
	            this.props.onSetActive(to);
	          }
	
	          scrollSpy.updateStates();
	        }
	      },
	
	      componentDidMount: function() {
	
	
	
	        var containerId = this.props.containerId;
	
	        var scrollSpyContainer = containerId ? document.getElementById(containerId) : document;
	
	        if(!scrollSpy.isMounted(scrollSpyContainer)) {
	          scrollSpy.mount(scrollSpyContainer);
	        }
	
	
	        if(this.props.spy) {
	          var to = this.props.to;
	          var element = null;
	          var elemTopBound = 0;
	          var elemBottomBound = 0;
	
	          this._stateHandler = function() {
	            if(scroller.getActiveLink() != to) {
	                this.setState({ active : false });
	            }
	          }.bind(this)
	
	          scrollSpy.addStateHandler(this._stateHandler);
	
	          this._spyHandler = function(y) {
	
	            var containerTop = 0;
	            if(scrollSpyContainer.getBoundingClientRect) {
	              var containerCords = scrollSpyContainer.getBoundingClientRect();
	              containerTop = containerCords.top;
	            }
	
	            if(!element || this.props.isDynamic) {
	                element = scroller.get(to);
	                if(!element){ return;}
	
	                var cords = element.getBoundingClientRect();
	                elemTopBound = (cords.top - containerTop + y);
	                elemBottomBound = elemTopBound + cords.height;
	            }
	
	
	
	            var offsetY = y - this.props.offset;
	            var isInside = (offsetY >= Math.floor(elemTopBound) && offsetY <= Math.floor(elemBottomBound));
	            var isOutside = (offsetY < Math.floor(elemTopBound) || offsetY > Math.floor(elemBottomBound));
	            var activeLink = scroller.getActiveLink();
	
	            if (isOutside && activeLink === to) {
	              scroller.setActiveLink(void 0);
	              this.setState({ active : false });
	
	            } else if (isInside && activeLink != to) {
	              scroller.setActiveLink(to);
	              this.setState({ active : true });
	
	              if(this.props.onSetActive) {
	                this.props.onSetActive(to);
	              }
	
	              scrollSpy.updateStates();
	
	            }
	          }.bind(this);
	
	          scrollSpy.addSpyHandler(this._spyHandler, scrollSpyContainer);
	        }
	      },
	      componentWillUnmount: function() {
	        scrollSpy.unmount(this._stateHandler, this._spyHandler);
	      },
	      render: function() {
	
	        var className = "";
	        if(this.state && this.state.active) {
	          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
	        } else {
	          className = this.props.className;
	        }
	
	        var props = assign({}, this.props);
	
	        for(var prop in protoTypes) {
	          if(props.hasOwnProperty(prop)) {
	            delete props[prop];
	          }
	        }
	
	        props.className = className;
	        props.onClick = this.handleClick;
	
	        return React.createElement(Component, props);
	      }
	    });
	  },
	
	
	  Element: function(Component) {
	    return React.createClass({
	      propTypes: {
	        name: React.PropTypes.string,
	        id:   React.PropTypes.string
	      },
	      componentDidMount: function() {
	        this.registerElems(this.props.name);
	      },
	      componentWillReceiveProps: function(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          this.registerElems(nextProps.name);
	        }
	      },
	      componentWillUnmount: function() {
	        defaultScroller.unregister(this.props.name);
	      },
	      registerElems: function(name) {
	        var domNode = ReactDOM.findDOMNode(this);
	        defaultScroller.register(name, domNode);
	      },
	      render: function() {
	        return React.createElement(Component, this.props);
	      }
	    });
	  }
	};
	
	module.exports = Helpers;


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sk-folding-cube":"_3ZAb3_qiNCia2o-S1wIY3c","sk-cube":"cM_IClr0gGW5A2Imk2vxW","sk-foldCubeAngle":"_16bGu_rygZvtWh0Tu77F8W","sk-cube2":"rMPTh051RdQo66Hop6tBJ cM_IClr0gGW5A2Imk2vxW","sk-cube3":"_3JGd_SX97yM_QOw9kD-BhP cM_IClr0gGW5A2Imk2vxW","sk-cube4":"_3ilhocWnejoD6gplyLVdAU cM_IClr0gGW5A2Imk2vxW"};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(28);
	
	var smooth = __webpack_require__(104);
	
	var easing = smooth.defaultEasing;
	
	var cancelEvents = __webpack_require__(103);
	
	var events = __webpack_require__(51);
	
	/*
	 * Function helper
	 */
	var functionWrapper = function(value) {
	  return typeof value === 'function' ? value : function() { return value; };
	};
	
	/*
	 * Sets the cancel trigger
	 */
	
	cancelEvents.register(function() {
	  __cancel = true;
	});
	
	/*
	 * Wraps window properties to allow server side rendering
	 */
	var currentWindowProperties = function() {
	  if (typeof window !== 'undefined') {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
	  }
	};
	
	/*
	 * Helper function to never extend 60fps on the webpage.
	 */
	var requestAnimationFrameHelper = (function () {
	  return  currentWindowProperties() ||
	          function (callback, element, delay) {
	              window.setTimeout(callback, delay || (1000/60), new Date().getTime());
	          };
	})();
	
	
	var __currentPositionY  = 0;
	var __startPositionY    = 0;
	var __targetPositionY   = 0;
	var __progress          = 0;
	var __duration          = 0;
	var __cancel            = false;
	
	var __target;
	var __containerElement;
	var __to;
	var __start;
	var __deltaTop;
	var __percent;
	var __delayTimeout;
	
	
	var currentPositionY = function() {
	  if (__containerElement) {
	        return __containerElement.scrollTop;
		} else {
	    var supportPageOffset = window.pageXOffset !== undefined;
	    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	    return supportPageOffset ? window.pageYOffset : isCSS1Compat ?
	           document.documentElement.scrollTop : document.body.scrollTop;
	   }
	};
	
	var scrollContainerHeight = function() {
	  if(__containerElement) {
	    return Math.max(
	      __containerElement.scrollHeight,
	      __containerElement.offsetHeight,
	      __containerElement.clientHeight
	    );
	  } else {
	    var body = document.body;
	    var html = document.documentElement;
	
	    return Math.max(
	      body.scrollHeight,
	      body.offsetHeight,
	      html.clientHeight,
	      html.scrollHeight,
	      html.offsetHeight
	    );
	  }
	};
	
	var animateTopScroll = function(timestamp) {
	  // Cancel on specific events
	  if(__cancel) { return };
	
	  __deltaTop = Math.round(__targetPositionY - __startPositionY);
	
	  if (__start === null) {
	    __start = timestamp;
	  }
	
	  __progress = timestamp - __start;
	
	  __percent = (__progress >= __duration ? 1 : easing(__progress/__duration));
	
	  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);
	
	  if(__containerElement) {
	    __containerElement.scrollTop = __currentPositionY;
	  } else {
	    window.scrollTo(0, __currentPositionY);
	  }
	
	  if(__percent < 1) {
	    requestAnimationFrameHelper.call(window, animateTopScroll);
	    return;
	  }
	
	  if(events.registered['end']) {
	    events.registered['end'](__to, __target, __currentPositionY);
	  }
	
	};
	
	var setContainer = function (options) {
	  if(!options || !options.containerId) {
	    __containerElement = null;
	    return;
	  }
	  if(!__containerElement) {
		   __containerElement = document.getElementById(options.containerId);
	  }
	};
	
	var startAnimateTopScroll = function(y, options, to, target) {
	
	  window.clearTimeout(__delayTimeout);
	
	  setContainer(options);
	
	
	  __start           = null;
	  __cancel          = false;
	  __startPositionY  = currentPositionY();
	  __targetPositionY = options.absolute ? y : y + __startPositionY;
	  __deltaTop        = Math.round(__targetPositionY - __startPositionY);
	
	  __duration        = functionWrapper(options.duration)(__deltaTop);
	  __duration        = isNaN(parseFloat(__duration)) ? 1000 : parseFloat(__duration);
	  __to              = to;
	  __target          = target;
	
	  if(options && options.delay > 0) {
	    __delayTimeout = window.setTimeout(function animate() {
	      requestAnimationFrameHelper.call(window, animateTopScroll);
	    }, options.delay);
	    return;
	  }
	
	  requestAnimationFrameHelper.call(window, animateTopScroll);
	
	};
	
	var scrollToTop = function (options) {
	  startAnimateTopScroll(0, assign(options || {}, { absolute : true }));
	};
	
	var scrollTo = function (toY, options) {
	  startAnimateTopScroll(toY, assign(options || {}, { absolute : true }));
	};
	
	var scrollToBottom = function(options) {
	  setContainer(options);
	  startAnimateTopScroll(scrollContainerHeight(), assign(options || {}, { absolute : true }));
	};
	
	var scrollMore = function(toY, options) {
	  setContainer(options);
	  startAnimateTopScroll(currentPositionY() + toY, assign(options || {}, { absolute : true }));
	};
	
	module.exports = {
	  animateTopScroll: startAnimateTopScroll,
	  scrollToTop: scrollToTop,
	  scrollToBottom: scrollToBottom,
	  scrollTo: scrollTo,
	  scrollMore: scrollMore,
	};


/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	
	var Events = {
		registered : {},
		scrollEvent : {
			register: function(evtName, callback) {
				Events.registered[evtName] = callback;
			},
			remove: function(evtName) {
				Events.registered[evtName] = null;
			}
		}
	};
	
	module.exports = Events;

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"breadcrumb-item":"_3lyK8OooH9BWh1wHXAdwTL","breadcrumb-last-item":"_2rO8V_yo7fat1Rv3nlfC3Z","separator":"_1Z2WQR0IcvSWaAgxtmgljU","breadcrumb":"_17ZA2aQYdxXc7mteT2QDuM _13UyNN6lRQaIE4nGDzE2-d","breadcrumb-hidden":"_1W4CorlN8AMJGoX4oKVBqr"};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Breadcrumbs = __webpack_require__(62);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _config = __webpack_require__(37);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Breadcrumbs: {
	    displayName: 'Breadcrumbs'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Breadcrumbs/Breadcrumbs.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Breadcrumbs = _wrapComponent('Breadcrumbs')((_dec = (0, _reactCssModules2.default)(_Breadcrumbs2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Breadcrumbs, _Component);
	
	  function Breadcrumbs() {
	    (0, _classCallCheck3.default)(this, Breadcrumbs);
	    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Breadcrumbs, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          trip = _props.trip,
	          localExpert = _props.localExpert,
	          inspiration = _props.inspiration,
	          customStyle = _props.customStyle;
	
	      var separator = function separator(key) {
	        return _react3.default.createElement('i', { className: 'fa fa-angle-right', styleName: 'separator', key: 'separator-' + key });
	      };
	      return _react3.default.createElement(
	        'span',
	        { styleName: 'breadcrumb', style: customStyle, itemScope: true, itemType: 'http://schema.org/BreadcrumbList' },
	        _react3.default.createElement(
	          'span',
	          { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem' },
	          _react3.default.createElement(
	            'a',
	            { itemProp: 'item', href: '/' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'breadcrumb-item', itemProp: 'name' },
	              'Home'
	            ),
	            _react3.default.createElement('meta', { itemProp: 'position', content: '1' })
	          )
	        ),
	        function () {
	          switch (type) {
	            case 'TripDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/to/' + encodeURIComponent(trip.destination_location) },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    trip.destination_location
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  trip.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' })
	              )];
	            case 'LocalExpertProfile':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  localExpert.name.first + ' ' + localExpert.name.last
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Inspirations':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Inspiration'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration '
	                })
	              )];
	            case 'InspirationDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/inspiration' },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    'Inspiration'
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  inspiration.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration/' + inspiration.slug
	                })
	              )];
	            case 'Career':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Career'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/career'
	                })
	              )];
	            case 'TrustAndSafety':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Trust & Safety'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/trust-and-safety'
	                })
	              )];
	            case 'Dtac':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Dtac'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Digi':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Digi'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/digi'
	                })
	              )];
	            case 'LocalExpertBenefits':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Local Expert Benefits'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/local-expert-benefits'
	                })
	              )];
	            case 'Sitemap':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Sitemap'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/sitemap'
	                })
	              )];
	            default:
	              return null;
	          }
	        }()
	      );
	    }
	  }]);
	  return Breadcrumbs;
	}(_react2.Component), _class2.propTypes = {
	  type: _react2.PropTypes.string.isRequired,
	  trip: _react2.PropTypes.object,
	  localExpert: _react2.PropTypes.object,
	  inspiration: _react2.PropTypes.object,
	  customStyle: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Breadcrumbs;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	/*
	 * Tell the browser that the event listener won't prevent a scroll.
	 * Allowing the browser to continue scrolling without having to
	 * to wait for the listener to return.
	 */
	var addPassiveEventListener = function(target, eventName, listener) {
	    var supportsPassiveOption = (function(){
	        var supportsPassiveOption = false;
	        try {
	            var opts = Object.defineProperty({}, 'passive', {
	                get: function() {
	                    supportsPassiveOption = true;
	                }
	            });
	            window.addEventListener('test', null, opts);
	        } catch (e) {}
	        return supportsPassiveOption;
	    })();
	
	    target.addEventListener(eventName, listener, supportsPassiveOption ? {passive: true} : false);
	};
	
	module.exports = addPassiveEventListener;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	var addPassiveEventListener = __webpack_require__(67);
	
	var eventThrottler = function(eventHandler) {
	  var eventHandlerTimeout;
	  return function(event) {
	    // ignore events as long as an eventHandler execution is in the queue
	    if ( !eventHandlerTimeout ) {
	      eventHandlerTimeout = setTimeout(function() {
	        eventHandlerTimeout = null;
	        eventHandler(event);
	        // The eventHandler will execute at a rate of 15fps
	      }, 66);
	    }
	  };
	};
	
	var scrollSpy = {
	
	  spyCallbacks: [],
	  spySetState: [],
	  scrollSpyContainers: [],
	
	  mount: function (scrollSpyContainer) {
	    var t = this;
	    if (scrollSpyContainer) {
	      var eventHandler = eventThrottler(function(event) {
	        t.scrollHandler(scrollSpyContainer);
	      });
	      this.scrollSpyContainers.push(scrollSpyContainer);
	      addPassiveEventListener(scrollSpyContainer, 'scroll', eventHandler);
	    }
	  },
	
	  isMounted: function (scrollSpyContainer) {
	    return this.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
	  },
	
	  currentPositionY: function (scrollSpyContainer) {
	    if(scrollSpyContainer === document) {
	      var supportPageOffset = window.pageXOffset !== undefined;
	      var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	      return supportPageOffset ? window.pageYOffset : isCSS1Compat ?
	      document.documentElement.scrollTop : document.body.scrollTop;
	    } else {
	      return scrollSpyContainer.scrollTop;
	    }
	  },
	
	  scrollHandler: function (scrollSpyContainer) {
	    var callbacks = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks;
	    if (callbacks) {
	      for(var i = 0; i < callbacks.length; i++) {
	        var position =this.currentPositionY(scrollSpyContainer);
	        callbacks[i](this.currentPositionY(scrollSpyContainer));
	      }
	    }
	  },
	
	  addStateHandler: function(handler){
	    this.spySetState.push(handler);
	  },
	
	  addSpyHandler: function(handler, scrollSpyContainer) {
	    var container = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)];
	    if(!container.spyCallbacks) {
	      container.spyCallbacks = [];
	    }
	    container.spyCallbacks.push(handler);
	  },
	
	  updateStates: function(){
	    var length = this.spySetState.length;
	
	    for(var i = 0; i < length; i++) {
	      this.spySetState[i]();
	    }
	  },
	
	  unmount: function (stateHandler, spyHandler) {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      var callbacks = this.scrollSpyContainers[i].spyCallbacks;
	      if(callbacks && callbacks.length) {
	        callbacks.splice(callbacks.indexOf(spyHandler), 1);
	      }
	    }
	
	    if(this.spySetState && this.spySetState.length) {
	      this.spySetState.splice(this.spySetState.indexOf(stateHandler), 1);
	    }
	
	    document.removeEventListener('scroll', this.scrollHandler);
	  },
	
	  update: function() {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      this.scrollHandler(this.scrollSpyContainers[i]);
	    }
	  }
	}
	
	module.exports = scrollSpy;


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(28);
	
	var animateScroll = __webpack_require__(50);
	var events = __webpack_require__(51);
	
	var __mapped = {};
	var __activeLink;
	
	module.exports = {
	
	  unmount: function() {
	    __mapped = {};
	  },
	
	  register: function(name, element){
	    __mapped[name] = element;
	  },
	
	  unregister: function(name) {
	    delete __mapped[name];
	  },
	
	  get: function(name) {
	    return __mapped[name] || document.getElementById(name);
	  },
	
	  setActiveLink: function(link) {
	    __activeLink = link;
	  },
	
	  getActiveLink: function() {
	    return __activeLink;
	  },
	
	  scrollTo: function(to, props) {
	
	     /*
	     * get the mapped DOM element
	     */
	
	      var target = this.get(to);
	
	      if(!target) {
	        console.warn("target Element not found");
	        return;
	      }
	
	      props = assign({}, props, { absolute : false });
	
	
	      if(events.registered['begin']) {
	        events.registered['begin'](to, target);
	      }
	
	      var containerId = props.containerId;
	      var containerElement = containerId ? document.getElementById(containerId) : null;
	
	      var scrollOffset;
	
	      if(containerId && containerElement) {
	        props.absolute = true;
	        if(containerElement !== target.offsetParent) {
	          if(!containerElement.contains(target)) {
	            throw new Error('Container with ID ' + containerId + ' is not a parent of target ' + to);
	          } else {
	            throw new Error('Container with ID ' + containerId + ' is not a positioned element');
	          }
	        }
	
	        scrollOffset = target.offsetTop;
	      } else {
	        var coordinates = target.getBoundingClientRect();
	        var bodyRect = document.body.getBoundingClientRect();
	        scrollOffset = coordinates.top;
	      }
	
	      scrollOffset += (props.offset || 0);
	
	
	      /*
	       * if animate is not provided just scroll into the view
	       */
	      if(!props.smooth) {
	        if(containerId && containerElement) {
	          containerElement.scrollTop = scrollOffset;
	        } else {
	          window.scrollTo(0, scrollOffset);
	        }
	
	        if(events.registered['end']) {
	          events.registered['end'](to, target);
	        }
	
	        return;
	      }
	
	      /*
	       * Animate scrolling
	       */
	
	      animateScroll.animateTopScroll(scrollOffset, props, to, target);
	  }
	};


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	exports.Link = __webpack_require__(102);
	exports.Button = __webpack_require__(100);
	exports.Element = __webpack_require__(101);
	exports.Helpers = __webpack_require__(36);
	exports.scroller = __webpack_require__(69);
	exports.Events = __webpack_require__(51);
	exports.scrollSpy = __webpack_require__(68);
	exports.animateScroll = __webpack_require__(50);


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(36);
	
	var Button = React.createClass({
	  render: function () {
	    return React.DOM.input(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Scroll(Button);


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(36);
	
	var Element = React.createClass({
	  render: function () {
	    return React.DOM.div(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Element(Element);


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(36);
	
	var Link = React.createClass({
	  render: function () {
	    return React.DOM.a(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Scroll(Link);


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	var addPassiveEventListener = __webpack_require__(67);
	
	var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown']
	
	module.exports = {
		register : function(cancelEvent) {
			if (typeof document === 'undefined') {
				return;
			}
	
			for(var i = 0; i < events.length; i = i + 1) {
				addPassiveEventListener(document, events[i], cancelEvent);
			}
		}
	};


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	module.exports = {
	 /*
	  * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
	  */
	  defaultEasing : function (x) {
	    'use strict';
	
	    if(x < 0.5) {
	      return Math.pow(x*2, 2)/2;
	    }
	    return 1-Math.pow((1-x)*2, 2)/2;
	  }
	}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(11);
	
	var _session = __webpack_require__(22);
	
	var sessionActions = _interopRequireWildcard(_session);
	
	var _trip = __webpack_require__(47);
	
	var _payment = __webpack_require__(46);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	var _DefaultTrip = __webpack_require__(132);
	
	var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);
	
	var _ZHTrip = __webpack_require__(135);
	
	var _ZHTrip2 = _interopRequireDefault(_ZHTrip);
	
	var _SharedTrip = __webpack_require__(134);
	
	var _SharedTrip2 = _interopRequireDefault(_SharedTrip);
	
	var _PrivateGuideTrip = __webpack_require__(133);
	
	var _PrivateGuideTrip2 = _interopRequireDefault(_PrivateGuideTrip);
	
	var _helpers = __webpack_require__(19);
	
	var _price = __webpack_require__(60);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Trip: {
	    displayName: 'Trip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/Trip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Trip = _wrapComponent('Trip')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sessionData: state.session.data,
	    rates: state.info.exchangeRates,
	    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
	    omitBookingFee: state.info.userConfig.omitBookingFee,
	    siteConfigs: state.info.siteConfigs,
	    tripBookNow: state.info.userConfig.tripBookNow
	  };
	}, (0, _extends3.default)({}, sessionActions, { openExternal: _trip.openExternal, clickTrip: _trip.clickTrip, impressTrip: _trip.impressTrip, loadTripDetail: _trip.load, setPaymentData: _payment.setPaymentData, push: _reactRouterRedux.push, logClickBookNow: _trip.logClickBookNow })), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Trip, _Component);
	
	  function Trip(props) {
	    (0, _classCallCheck3.default)(this, Trip);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Trip.__proto__ || (0, _getPrototypeOf2.default)(Trip)).call(this, props));
	
	    _this.impress = _this.impress.bind(_this);
	
	    if (!(typeof _this.impress === 'function')) {
	      throw new TypeError('Value of "this.impress" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.impress));
	    }
	
	    _this.click = _this.click.bind(_this);
	
	    if (!(typeof _this.click === 'function')) {
	      throw new TypeError('Value of "this.click" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.click));
	    }
	
	    _this.requestBook = _this.requestBook.bind(_this);
	
	    if (!(typeof _this.requestBook === 'function')) {
	      throw new TypeError('Value of "this.requestBook" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.requestBook));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Trip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.interval = setInterval(function () {
	        var rect = _this2.refs.root.getBoundingClientRect();
	        var elemCenter = (rect.top + rect.bottom * 2) / 3;
	        if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
	          _this2.impress();
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.interval) {
	        clearInterval(this.interval);
	      }
	    }
	  }, {
	    key: 'getQuantity',
	    value: function getQuantity(maxTravelers) {
	      return this.props.sessionData.quantity > maxTravelers ? maxTravelers : this.props.sessionData.quantity;
	    }
	  }, {
	    key: 'impress',
	    value: function impress() {
	      if (this.interval) {
	        clearInterval(this.interval);
	        this.interval = null;
	        this.props.impressTrip(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
	      }
	    }
	  }, {
	    key: 'click',
	    value: function click() {
	      this.props.clickTrip(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
	      this.impress();
	      if (this.props.trip.is_external) {
	        this.props.openExternal(this.props.trip.external_url);
	      }
	    }
	  }, {
	    key: 'requestBook',
	    value: function requestBook() {
	      this.props.logClickBookNow(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
	      this.props.push('/booking/new?trip=' + this.props.trip.slug + '&device=bookNow&requestType=book');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          trip = _props.trip,
	          sessionData = _props.sessionData,
	          rates = _props.rates,
	          omitBookingFee = _props.omitBookingFee,
	          type = _props.type,
	          tripBookNow = _props.tripBookNow;
	      var quantity = sessionData.quantity,
	          currency = sessionData.currency;
	
	      var thumbnailCurrency = this.props.currency;
	      var displayPrice = (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), thumbnailCurrency || currency, rates));
	      var displaySeasonedPrice = (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplaySeasonedPrice)(quantity, trip.full_prices, omitBookingFee), thumbnailCurrency || currency, rates));
	      return _react3.default.createElement(
	        'div',
	        { ref: 'root', onClick: this.click },
	        function () {
	          switch (type) {
	            case 'tour_shared':
	              return _react3.default.createElement(_SharedTrip2.default, { trip: trip, prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency });
	            case 'tour_private':
	              return _react3.default.createElement(_PrivateGuideTrip2.default, { trip: trip, prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency });
	            case 'zh':
	              return _react3.default.createElement(_ZHTrip2.default, { trip: trip, prices: { displayPrice: displayPrice } });
	            default:
	              return _react3.default.createElement(_DefaultTrip2.default, (0, _extends3.default)({}, _this3.props, { prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency, thumbnailCurrency: thumbnailCurrency, tripBookNow: tripBookNow, requestBook: _this3.requestBook }));
	          }
	        }()
	      );
	    }
	  }]);
	  return Trip;
	}(_react2.Component), _class2.propTypes = {
	  tripBookNow: _react2.PropTypes.bool,
	  omitBookingFee: _react2.PropTypes.bool,
	  index: _react2.PropTypes.number,
	  type: _react2.PropTypes.string,
	  from: _react2.PropTypes.string,
	  target: _react2.PropTypes.string,
	  currency: _react2.PropTypes.string,
	  searchSessionId: _react2.PropTypes.string,
	  trip: _react2.PropTypes.object,
	  rates: _react2.PropTypes.object,
	  sessionData: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  push: _react2.PropTypes.func,
	  clickTrip: _react2.PropTypes.func,
	  impressTrip: _react2.PropTypes.func,
	  openExternal: _react2.PropTypes.func,
	  loadTripDetail: _react2.PropTypes.func,
	  setPaymentData: _react2.PropTypes.func,
	  logClickBookNow: _react2.PropTypes.func
	}, _class2.defaultProps = {
	  target: null,
	  searchSessionId: null
	}, _temp)) || _class));
	
	exports.default = Trip;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"S16neekU--3fHtjFUW3V4","request-box":"_1HpW-mWPnjwergIwbdFOW0","arrow-right":"nU8vUKz_bxN-G6gW1kXGq","content-container":"Fdq8T8diV3cWK4V-fbE1","trip-name":"_3wlC7iocT32wo1qKSGI0G4","all-tags":"WNMMChMfXcTJUrgb_lvcx","tag-transport":"_2hA0qQMpT6u97OpbNPxiW7 _3hNMZ7oH3iw0LhoRYKg4Be _8NfZBr7F1U7HBWP4_gM6n","tag-inclusive":"_3NIPRl0LIwh2FE5fjdZfjN tp9wLzyXfr971sR8NG67C _8NfZBr7F1U7HBWP4_gM6n","tag-pickup":"_1MirGn3SQ_9POiPwQ805J _1vNs2PB4OE3qwqCoIlPKsr _8NfZBr7F1U7HBWP4_gM6n","trip-prices":"_3uPRP9r93zqTIYFzTWZYcZ","discount-percent-container":"_3pX78LeFU10f16UBuqlyta","discount-percent":"_3JzS6Pt6w2Q0dr5_VcVvfG","price-container":"_2ldU9F0mtPQbefrPA9MgRp","discount-price":"_2UV28yBSpzZd-_NuaoPxV1","sale-price":"_1q78IWBieXDGTSMA2feobV","per-person":"_1Sipp0Hl_FwQG17D-Xa8lx"};

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_2jwbwEEZ6e82LFlG-1MXrw","trip-image":"_3kqcKraaxttGgJQ3siWUvq","trip-content":"ZXD68yIZ5asmJEAPl6jVC","trip-name":"_1q3Pe400Jzrhs52HgE6GJ7","trip-prices":"EKCjWLxdGhPXXCsSIWrEi","price-container":"c7e8X_nAVX4O5Bugq6iCJ","discount-price":"nUfmkEXcwBjM6zlK5KzcP","sale-price":"_2Iy9Fxwn-K1oc1Yjp_KNZf","discount-percent-container":"_3SOt4AaXqr8xHux60ESiRo","discount-percent":"_3ois-L5bK79YC3E7u4Oqxs","per-person":"_24mu7OM70V-2pi4GknUdsw"};

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"trip-image":"_3f_RcmX8exEgmLnHoRTnEt","trip-content":"_3U-DfJDDm1h2cl6KOfiOqs","trip-name":"_1u0_qUyrLAezuwvUPCHriV","trip-rating-container":"_1g0wbfVBH1n2IbXWYLqw3n","trip-footer":"_15OhQEkAgraIMr5dvKiVH9","review-count":"_2E9E8abLdLQI3eMxoCVX_g","price":"_3qLgG-sCJs97CXTYhXALWa","price-price":"_3_lF2RZq__cu5Op0Gxpb5C","price-per-person":"_1pHrLEDZVwEp2B34yaUHf"};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cefd59bdd40f7c47f23ed32f443b479f.png";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _DefaultTrip = __webpack_require__(191);
	
	var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _WishlistButton = __webpack_require__(146);
	
	var _WishlistButton2 = _interopRequireDefault(_WishlistButton);
	
	var _helpers = __webpack_require__(19);
	
	var _media = __webpack_require__(21);
	
	var _trip = __webpack_require__(38);
	
	var _helpers2 = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Trip: {
	    displayName: 'Trip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/DefaultTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Trip = _wrapComponent('Trip')((_dec = (0, _reactCssModules2.default)(_DefaultTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Trip, _Component);
	
	  function Trip(props) {
	    (0, _classCallCheck3.default)(this, Trip);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Trip.__proto__ || (0, _getPrototypeOf2.default)(Trip)).call(this, props));
	
	    _this.renderPriceMobile = _this.renderPriceMobile.bind(_this);
	
	    if (!(typeof _this.renderPriceMobile === 'function')) {
	      throw new TypeError('Value of "this.renderPriceMobile" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.renderPriceMobile));
	    }
	
	    _this.renderPriceContent = _this.renderPriceContent.bind(_this);
	
	    if (!(typeof _this.renderPriceContent === 'function')) {
	      throw new TypeError('Value of "this.renderPriceContent" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.renderPriceContent));
	    }
	
	    _this.renderTrip = _this.renderTrip.bind(_this);
	
	    if (!(typeof _this.renderTrip === 'function')) {
	      throw new TypeError('Value of "this.renderTrip" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderTrip));
	    }
	
	    _this.isVerified = _this.isVerified.bind(_this);
	
	    if (!(typeof _this.isVerified === 'function')) {
	      throw new TypeError('Value of "this.isVerified" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.isVerified));
	    }
	
	    _this.requestBook = _this.requestBook.bind(_this);
	
	    if (!(typeof _this.requestBook === 'function')) {
	      throw new TypeError('Value of "this.requestBook" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.requestBook));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Trip, [{
	    key: 'isVerified',
	    value: function isVerified() {
	      var trip = this.props.trip;
	
	      var user = trip.user_id;
	      var count = 0;
	      if (user && user.verification) {
	        if (user.verification.mobile_verified) {
	          count += 1;
	        }
	        if (user.verification.id_card_verified) {
	          count += 1;
	        }
	        if (user.verification.email_verified) {
	          count += 1;
	        }
	        if (user.verification.facebook_verified) {
	          count += 1;
	        }
	      }
	      if (count >= 2) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'requestBook',
	    value: function requestBook(e) {
	      e.preventDefault();
	      this.props.requestBook();
	    }
	  }, {
	    key: 'renderPriceMobile',
	    value: function renderPriceMobile(currency) {
	      var _props = this.props,
	          siteConfigs = _props.siteConfigs,
	          prices = _props.prices,
	          trip = _props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'price-mobile-container' },
	        _react3.default.createElement(
	          'span',
	          { styleName: 'person-mobile' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_person' })
	        ),
	        _react3.default.createElement(
	          'span',
	          { styleName: 'price-mobile' },
	          prices.displayPrice,
	          ' ',
	          siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	        ),
	        trip.discount_percentage > 0 ? _react3.default.createElement(
	          'span',
	          { styleName: 'cross-price-mobile' },
	          prices.displaySeasonedPrice
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderPriceContent',
	    value: function renderPriceContent(currency) {
	      var _props2 = this.props,
	          siteConfigs = _props2.siteConfigs,
	          prices = _props2.prices,
	          trip = _props2.trip;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'trip-content-price' },
	        trip.discount_percentage > 0 ? _react3.default.createElement(
	          'span',
	          { styleName: 'cross-price' },
	          _react3.default.createElement(
	            'span',
	            null,
	            prices.displaySeasonedPrice,
	            ' ',
	            siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	          )
	        ) : null,
	        _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement(
	            'span',
	            { styleName: 'price' },
	            prices.displayPrice,
	            ' ',
	            siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	          ),
	          '\xA0',
	          _react3.default.createElement(
	            'span',
	            { styleName: 'person' },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'all-tags' },
	          (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
	            return _react3.default.createElement(
	              'div',
	              { key: index, styleName: tag.style },
	              _react3.default.createElement('i', null),
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderTrip',
	    value: function renderTrip() {
	      var pinImage = __webpack_require__(168);
	      var pinImageMobile = __webpack_require__(127);
	      var defaultImage = __webpack_require__(48);
	      var _props3 = this.props,
	          trip = _props3.trip,
	          currency = _props3.currency,
	          isWishlisted = _props3.isWishlisted,
	          siteConfigs = _props3.siteConfigs,
	          disableWishlist = _props3.disableWishlist,
	          thumbnailCurrency = _props3.thumbnailCurrency,
	          tripBookNow = _props3.tripBookNow,
	          disableBookNow = _props3.disableBookNow;
	
	      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
	      var transportation = (0, _trip.getTransportation)(trip.transportation);
	      return _react3.default.createElement(
	        'div',
	        { ref: 'root', styleName: 'trip-container', id: trip._id },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'trip-picture' },
	          _react3.default.createElement('img', { src: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard'), styleName: 'trip-picture-img', alt: trip.name }),
	          trip.video_url && _react3.default.createElement('div', { styleName: 'play-icon' }),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-picture-shadow' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-picture-shadow-flex' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'trip-picture-location-point' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'location' },
	                  _react3.default.createElement('img', { src: pinImage, width: '10', height: '15', alt: 'pin' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    this.props.from && this.props.from !== trip.destination_location ? 'From ' + this.props.from : trip.destination_location
	                  )
	                ),
	                trip.rating > 0 && _react3.default.createElement(
	                  'div',
	                  { styleName: 'review-flex' },
	                  _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'review-count' },
	                    '(',
	                    trip.review_count,
	                    ' ',
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.reviews' }),
	                    ')'
	                  )
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'lx-picture-mobile' },
	                !siteConfigs.tripHideLx && _react3.default.createElement(
	                  'div',
	                  { styleName: 'trip-content-lx-pic-container' },
	                  this.isVerified() && _react3.default.createElement('div', { styleName: 'verify-icon' }),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'trip-content-lx-pic' },
	                    _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'avatarTripCard') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
	                  )
	                )
	              ),
	              trip.discount_percentage ? _react3.default.createElement(
	                'div',
	                { styleName: 'trip-picture-discount' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'discount-amount' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                )
	              ) : null,
	              _react3.default.createElement(
	                'div',
	                { styleName: 'trip-price-mobile' },
	                thumbnailCurrency ? this.renderPriceMobile(thumbnailCurrency) : this.renderPriceMobile(currency),
	                trip.discount_percentage ? _react3.default.createElement(
	                  'div',
	                  { styleName: 'price-off-mobile' },
	                  _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                  )
	                ) : null
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'mobile-bg-action' },
	            _react3.default.createElement(
	              'div',
	              null,
	              (0, _helpers2.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'instant-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.available_tomorrow' })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
	                )
	              ),
	              trip.is_instant_confirmation && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'instant-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'search.search_filter.extra_conditions.instant_booking' })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
	                )
	              ),
	              trip.tmt_tag && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'tmt-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.exclusive' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-bottom' })
	                )
	              ),
	              trip.tags.some(function (s) {
	                return s.match(/_staff_pick$/);
	              }) && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'feature-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.feature' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'feature-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'feature-tag-arrow-bottom' })
	                )
	              ),
	              trip.rating > 0 && _react3.default.createElement(
	                'div',
	                { styleName: 'rating-mobile' },
	                _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'review-count' },
	                  '(',
	                  trip.review_count,
	                  ')'
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'wishlist-mobile' },
	              !disableWishlist && _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'trip-content' },
	          _react3.default.createElement(
	            'h3',
	            { className: 'trip-preview-name', styleName: 'trip-content-header' },
	            _react3.default.createElement(
	              'span',
	              null,
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'location-mobile' },
	              _react3.default.createElement('img', { src: pinImageMobile, width: '10', height: '15', alt: 'pin' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                this.props.from && this.props.from !== trip.destination_location ? 'From ' + this.props.from : trip.destination_location
	              )
	            )
	          ),
	          !siteConfigs.tripHideLx && _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content-lx' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-content-lx-pic-container' },
	              this.isVerified() && _react3.default.createElement('div', { styleName: 'verify-icon' }),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'trip-content-lx-pic' },
	                _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'avatarTripCard') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
	              )
	            ),
	            _react3.default.createElement(
	              'span',
	              null,
	              trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'content-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'content-row-wrapper' },
	              siteConfigs.tripHideLx && _react3.default.createElement(
	                'div',
	                { styleName: 'content-row' },
	                _react3.default.createElement('i', { styleName: 'view-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-label' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.view' }),
	                  ': '
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-value' },
	                  trip.view_count || 0
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'content-row' },
	                _react3.default.createElement('i', { styleName: 'duration-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-label' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.duration.label' }),
	                  ': '
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-value' },
	                  (0, _trip.getHour)(trip.duration),
	                  ' ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.hour' })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'content-row' },
	                _react3.default.createElement('i', { styleName: trip.transportation === 'Public Transportation' ? 'public-transportation-icon' : 'private-car-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-label' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.transportation.label' }),
	                  ': '
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-value' },
	                  transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'content-row-no-margin' },
	              _react3.default.createElement('i', { styleName: 'activity-icon' }),
	              _react3.default.createElement(
	                'span',
	                { styleName: 'content-label' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.activities.label' }),
	                ': '
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'activities-values' },
	                trip.activities && trip.activities.map(function (act) {
	                  return _react3.default.createElement(
	                    'span',
	                    { styleName: 'activity', key: act },
	                    act
	                  );
	                })
	              )
	            )
	          ),
	          (0, _helpers.getTripLabels)(trip).length > 0 && _react3.default.createElement(
	            'div',
	            { styleName: 'all-tags-mobile' },
	            (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
	              return _react3.default.createElement(
	                'div',
	                { key: index, styleName: tag.style },
	                _react3.default.createElement('i', null),
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
	              );
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content-action' },
	            thumbnailCurrency ? this.renderPriceContent(thumbnailCurrency) : this.renderPriceContent(currency),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'wishlist-container' },
	              !disableWishlist && _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
	            )
	          ),
	          tripBookNow && !disableBookNow && _react3.default.createElement(
	            'div',
	            { styleName: 'trip-book-now-action' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'more-info-btn' },
	              'More Info'
	            ),
	            _react3.default.createElement(
	              'span',
	              { styleName: 'book-now-btn', onClick: this.requestBook },
	              'Book Now'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          trip = _props4.trip,
	          target = _props4.target;
	
	      if (trip.is_external) {
	        return _react3.default.createElement(
	          'a',
	          { href: trip.external_url, target: target },
	          this.renderTrip()
	        );
	      }
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/trip/' + trip.slug, styleName: 'link', target: target },
	        this.renderTrip()
	      );
	    }
	  }]);
	  return Trip;
	}(_react2.Component), _class2.propTypes = {
	  tripBookNow: _react2.PropTypes.bool,
	  disableBookNow: _react2.PropTypes.bool,
	  disableWishlist: _react2.PropTypes.bool,
	  from: _react2.PropTypes.string,
	  target: _react2.PropTypes.string,
	  currency: _react2.PropTypes.string,
	  thumbnailCurrency: _react2.PropTypes.string,
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  requestBook: _react2.PropTypes.func
	}, _class2.defaultProps = {
	  target: null
	}, _temp)) || _class));
	
	exports.default = Trip;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PrivateGuideTrip = __webpack_require__(124);
	
	var _PrivateGuideTrip2 = _interopRequireDefault(_PrivateGuideTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(59);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _helpers = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  PrivateGuideTrip: {
	    displayName: 'PrivateGuideTrip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/PrivateGuideTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var PrivateGuideTrip = _wrapComponent('PrivateGuideTrip')((_dec = (0, _reactCssModules2.default)(_PrivateGuideTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PrivateGuideTrip, _Component);
	
	  function PrivateGuideTrip(props) {
	    (0, _classCallCheck3.default)(this, PrivateGuideTrip);
	    return (0, _possibleConstructorReturn3.default)(this, (PrivateGuideTrip.__proto__ || (0, _getPrototypeOf2.default)(PrivateGuideTrip)).call(this, props));
	  }
	  // onClick() {
	  //   this.props.onClick();
	  // }
	
	
	  (0, _createClass3.default)(PrivateGuideTrip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          prices = _props.prices,
	          currency = _props.currency;
	
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/customize/' + trip.slug },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'main-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'content-container' },
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'trip-name' },
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-prices' },
	              trip.discount_percentage > 0 && _react3.default.createElement(
	                'div',
	                { styleName: 'discount-percent-container' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'discount-percent' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'price-container' },
	                trip.discount_percentage > 0 && _react3.default.createElement(
	                  'span',
	                  { styleName: 'discount-price' },
	                  currency,
	                  ' ',
	                  prices.displaySeasonedPrice
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'sale-price' },
	                  currency,
	                  ' ',
	                  prices.displayPrice
	                )
	              ),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'per-person' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'all-tags' },
	              (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
	                return _react3.default.createElement(
	                  'div',
	                  { key: index, styleName: tag.style },
	                  _react3.default.createElement('i', null),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
	                );
	              })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'request-box' },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.request' }),
	            _react3.default.createElement(
	              'span',
	              { styleName: 'arrow-right' },
	              _react3.default.createElement(_reactFontawesome2.default, { name: 'chevron-right' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PrivateGuideTrip;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object,
	  currency: _react2.PropTypes.string
	}, _temp)) || _class));
	
	exports.default = PrivateGuideTrip;
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SharedTrip = __webpack_require__(125);
	
	var _SharedTrip2 = _interopRequireDefault(_SharedTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  SharedTrip: {
	    displayName: 'SharedTrip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/SharedTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var SharedTrip = _wrapComponent('SharedTrip')((_dec = (0, _reactCssModules2.default)(_SharedTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(SharedTrip, _Component);
	
	  function SharedTrip(props) {
	    (0, _classCallCheck3.default)(this, SharedTrip);
	    return (0, _possibleConstructorReturn3.default)(this, (SharedTrip.__proto__ || (0, _getPrototypeOf2.default)(SharedTrip)).call(this, props));
	  }
	  // onClick() {
	  //   this.props.onClick();
	  // }
	
	
	  (0, _createClass3.default)(SharedTrip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          prices = _props.prices,
	          currency = _props.currency;
	
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/trip/' + trip.slug },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'main-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-image', style: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard', true) },
	            trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content' },
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'trip-name' },
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-prices' },
	              trip.discount_percentage > 0 && _react3.default.createElement(
	                'div',
	                { styleName: 'discount-percent-container' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'discount-percent' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'price-container' },
	                trip.discount_percentage > 0 && _react3.default.createElement(
	                  'span',
	                  { styleName: 'discount-price' },
	                  currency,
	                  ' ',
	                  prices.displaySeasonedPrice
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'sale-price' },
	                  currency,
	                  ' ',
	                  prices.displayPrice
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'per-person' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return SharedTrip;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object,
	  currency: _react2.PropTypes.string
	}, _temp)) || _class));
	
	exports.default = SharedTrip;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ZHTrip = __webpack_require__(126);
	
	var _ZHTrip2 = _interopRequireDefault(_ZHTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ZHTrip: {
	    displayName: 'ZHTrip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/ZHTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ZHTrip = _wrapComponent('ZHTrip')((_dec = (0, _reactCssModules2.default)(_ZHTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ZHTrip, _Component);
	
	  function ZHTrip() {
	    (0, _classCallCheck3.default)(this, ZHTrip);
	    return (0, _possibleConstructorReturn3.default)(this, (ZHTrip.__proto__ || (0, _getPrototypeOf2.default)(ZHTrip)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ZHTrip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          prices = _props.prices;
	
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/trip/' + trip.slug },
	        _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement('div', { styles: 'trip-image', style: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard', true), styleName: 'trip-image' }),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content' },
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'trip-name' },
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-rating-container' },
	              trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-footer' },
	              trip.user_id && trip.user_id.rating && trip.user_id.rating.count > 0 && _react3.default.createElement(
	                'span',
	                { styleName: 'review-count' },
	                trip.user_id.rating.count,
	                ' ',
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.reviews' })
	              ),
	              _react3.default.createElement(
	                'span',
	                { styleName: 'price' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'price-price' },
	                  prices.displayPrice,
	                  ' \u5143'
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'price-per-person' },
	                  '/ ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_person' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ZHTrip;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = ZHTrip;
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"reply-submit-container":"_3cTkPud6xdbdw3V-0MtmFx","replier":"F2wYEnyhOAQMvJJhQd1SX","replier-pic":"_8E7KbDX7v42x0fqDh-P8l","replier-user-name":"_3YBWq0couzI9-2KDIBfyof","date":"hltMKG2aeWkFax_hPoQzh","reply-box-container":"_2Pr49W0FkE7JX2g50H93in","textbox-container":"_3v2X1iOf51ODrGiziH-kZ-","textbox":"cltGV8KeaXgP2HqV9_e-K","btn-reply-submit":"_1XLpOZfQfKrV_zHlg34COR _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","btn-reply-loading":"_2ob-OfdAohV12otU68xi2S _1XLpOZfQfKrV_zHlg34COR _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","btn-reply-disable":"_3HJN4JCG5TWA4e81-Lfa7P _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C"};

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"review-container":"_1JeonwlKeAJ0EgLobQ5rGN","reviewer":"_3fukzptnfhaXhpsm1e5KjJ","reviewer-pic":"_3Dso1LcvPd6-N-GstWg6SQ","review-user-name":"_1WoSPUbp0-oQwHNeHi2PYp","review-content":"HePMV2QwdAnCc7FMzSAbD","trip-link":"_3jcMF06F6BkUAtMEihkQSj","point-date":"_3OFMfTMsAVbB3srWgW9irP","btn-reply":"itBmByK3WMIp6VcbM6lQT","btn-reply-mobile":"tqoOZ18zGqF66Pe4IxEuL"};

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"reply-container":"_1pfpcaqCuBUQjSwVdj51KS","replier":"vxVJVX_KNraG3WOg5EzCH","replier-pic":"_3dH56iiynjHqicDkpc2n7w","replier-user-name":"_1h3pISwhe3DMVWAN6U0FbA","reply-content":"_1dADrJcr0FX7D9LFPbTWqE","date":"_3Lxo7_Ac_N63WoQRUz7txl"};

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"review-container":"_2IiB1rs7iE5xgS7mH3yoYX","reviewer":"_1_7EkspJ0zpHLVIZQF7EKD","reviewer-pic":"_2hVlwpnWPWcDmH0eLFNFWr","review-content":"_2E3yKFWx7nWeIg0N7QCD_Z","reviewer-name":"HWEdO6G63DkzuWswvV46o","review-p":"_25YGmKP4AysX6oEIRMJSFY"};

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ReplySubmit = __webpack_require__(250);
	
	var _ReplySubmit2 = _interopRequireDefault(_ReplySubmit);
	
	var _media = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(11);
	
	var _actions = __webpack_require__(78);
	
	var _reactIntl = __webpack_require__(10);
	
	var _LoadingButton = __webpack_require__(29);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ReplySubmit: {
	    displayName: 'ReplySubmit'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ReplySubmit.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var ReplySubmit = _wrapComponent('ReplySubmit')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sending: state.booking.sending
	  };
	}, { replyReview: _actions.replyReview }), _dec2 = (0, _reactCssModules2.default)(_ReplySubmit2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(ReplySubmit, _Component);
	
	  function ReplySubmit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ReplySubmit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReplySubmit.__proto__ || (0, _getPrototypeOf2.default)(ReplySubmit)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      text: ''
	    }, _this.onChange = function (event) {
	      _this.setState({ text: event.target.value });
	    }, _this.submit = function () {
	      _this.props.replyReview(_this.props.review._id, _this.state.text).then(function () {
	        return _this.props.onSubmit(_this.state.text);
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ReplySubmit, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var text = this.state.text;
	      var _props = this.props,
	          replier = _props.replier,
	          sending = _props.sending;
	
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'reply-submit-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'replier' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'replier-pic' },
	            _react3.default.createElement('img', { src: replier && replier.avatar_image ? (0, _media.path)(replier.avatar_image, 'profileAvatar') : defaultImage, alt: replier && replier.name && replier.name.first + ' ' + replier.name.last })
	          ),
	          _react3.default.createElement(
	            'span',
	            { className: 'replier-user-name', styleName: 'replier-user-name' },
	            replier && replier.name && '' + replier.name.first
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reply-box-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'textbox-container' },
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement('textarea', { styleName: 'textbox', value: text, onChange: this.onChange }),
	              function () {
	                if (text) {
	                  if (sending) {
	                    return _react3.default.createElement(
	                      'a',
	                      { styleName: 'btn-reply-loading' },
	                      _react3.default.createElement(_LoadingButton2.default, null),
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.loading.button' })
	                    );
	                  }
	                  return _react3.default.createElement(
	                    'a',
	                    { styleName: 'btn-reply-submit', onMouseDown: _this2.submit },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.submit.button' })
	                  );
	                }
	                return _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-reply-disable' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.disable.button' })
	                );
	              }()
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ReplySubmit;
	}(_react2.Component), _class2.propTypes = {
	  review: _react2.PropTypes.object,
	  replier: _react2.PropTypes.object,
	  sending: _react2.PropTypes.bool,
	  replyReview: _react2.PropTypes.func,
	  onSubmit: _react2.PropTypes.func
	}, _temp2)) || _class) || _class));
	
	exports.default = ReplySubmit;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Review = __webpack_require__(251);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ZHReview = __webpack_require__(264);
	
	var _ZHReview2 = _interopRequireDefault(_ZHReview);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _ReviewReply = __webpack_require__(263);
	
	var _ReviewReply2 = _interopRequireDefault(_ReviewReply);
	
	var _ReplySubmit = __webpack_require__(261);
	
	var _ReplySubmit2 = _interopRequireDefault(_ReplySubmit);
	
	var _reactIntl = __webpack_require__(10);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Review: {
	    displayName: 'Review'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/Review.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var Review = _wrapComponent('Review')((_dec = (0, _reactCssModules2.default)(_Review2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Review, _Component);
	
	  function Review(props) {
	    (0, _classCallCheck3.default)(this, Review);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Review.__proto__ || (0, _getPrototypeOf2.default)(Review)).call(this, props));
	
	    _this.state = {
	      openReply: false,
	      isSubmitted: false,
	      replyText: '',
	      createdAt: null
	    };
	
	    _this.openReplyBox = _this.openReplyBox.bind(_this);
	
	    if (!(typeof _this.openReplyBox === 'function')) {
	      throw new TypeError('Value of "this.openReplyBox" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openReplyBox));
	    }
	
	    _this.onReplyReview = _this.onReplyReview.bind(_this);
	
	    if (!(typeof _this.onReplyReview === 'function')) {
	      throw new TypeError('Value of "this.onReplyReview" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onReplyReview));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Review, [{
	    key: 'onReplyReview',
	    value: function onReplyReview(text) {
	      this.setState({ replyText: text });
	      this.setState({ isSubmitted: true });
	      this.setState({ createdAt: (0, _momentTimezone2.default)() });
	    }
	  }, {
	    key: 'openReplyBox',
	    value: function openReplyBox() {
	      if (this.state.openReply === false) {
	        this.setState({ openReply: true });
	      } else {
	        this.setState({ openReply: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const {review, locale} = this.props;
	      var _props = this.props,
	          review = _props.review,
	          forceLocale = _props.forceLocale,
	          user = _props.user;
	      var _state = this.state,
	          openReply = _state.openReply,
	          replyText = _state.replyText,
	          isSubmitted = _state.isSubmitted,
	          createdAt = _state.createdAt;
	
	      var defaultImage = __webpack_require__(48);
	      if (forceLocale === 'zh') {
	        return _react3.default.createElement(_ZHReview2.default, { review: review });
	      }
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'review-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reviewer' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'reviewer-pic' },
	            _react3.default.createElement('img', { src: review.user_id && review.user_id.avatar_image ? (0, _media.path)(review.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: review.user_id && review.user_id.name && review.user_id.name.first + ' ' + review.user_id.name.last })
	          ),
	          _react3.default.createElement(
	            'span',
	            { className: 'review-user-name', styleName: 'review-user-name' },
	            review.user_id && review.user_id.name && '' + review.user_id.name.first
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'review-content' },
	          review.trip_id && _react3.default.createElement(
	            'h3',
	            { style: { marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	            _react3.default.createElement(
	              _Link2.default,
	              { className: 'review-trip-name', to: '/trip/' + review.trip_id.slug, styleName: 'trip-link' },
	              review.trip_id.name
	            ),
	            review.local_expert_id._id === user._id && !review.reply && !isSubmitted && _react3.default.createElement(
	              'a',
	              { styleName: 'btn-reply', onClick: this.openReplyBox },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.button' })
	            )
	          ),
	          _react3.default.createElement(
	            'h3',
	            { className: 'review-title' },
	            review.header
	          ),
	          _react3.default.createElement(
	            'p',
	            null,
	            review && review.text && review.text.split('\n').map(function (line, index) {
	              if (index + 1 < review.text.split('\n').length) {
	                return [_react3.default.createElement(
	                  'span',
	                  { key: 'text-' + index },
	                  line
	                ), _react3.default.createElement('br', { key: 'break-' + index })];
	              }
	              return _react3.default.createElement(
	                'span',
	                { key: 'text-' + index },
	                line
	              );
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'point-date' },
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement(_RatingPoint2.default, { point: review.score })
	            ),
	            _react3.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	              _react3.default.createElement(
	                'span',
	                null,
	                (0, _momentTimezone2.default)(review.created_at).format('MMMM DD, YYYY')
	              ),
	              review.local_expert_id._id === user._id && !review.reply && !isSubmitted && _react3.default.createElement(
	                'a',
	                { styleName: 'btn-reply-mobile', onClick: this.openReplyBox },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.button' })
	              )
	            )
	          ),
	          review.reply && _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(_ReviewReply2.default, { reply: review.reply, replier: review.local_expert_id })
	          ),
	          isSubmitted && _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(_ReviewReply2.default, { reply: { text: replyText, created_at: createdAt }, replier: review.local_expert_id })
	          ),
	          !isSubmitted && _react3.default.createElement(
	            'div',
	            { style: openReply ? null : { display: 'none' } },
	            _react3.default.createElement(_ReplySubmit2.default, { review: review, replier: review.local_expert_id, onSubmit: this.onReplyReview })
	          )
	        )
	      );
	    }
	  }]);
	  return Review;
	}(_react2.Component), _class2.propTypes = {
	  review: _react2.PropTypes.object,
	  forceLocale: _react2.PropTypes.string,
	  user: _react2.PropTypes.object
	  // locale: PropTypes.string,
	}, _class2.defaultProps = {
	  forceLocale: null
	}, _temp)) || _class));
	
	exports.default = Review;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ReviewReply = __webpack_require__(252);
	
	var _ReviewReply2 = _interopRequireDefault(_ReviewReply);
	
	var _media = __webpack_require__(21);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ReviewReply: {
	    displayName: 'ReviewReply'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ReviewReply.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var ReviewReply = _wrapComponent('ReviewReply')((_dec = (0, _reactCssModules2.default)(_ReviewReply2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ReviewReply, _Component);
	
	  function ReviewReply() {
	    (0, _classCallCheck3.default)(this, ReviewReply);
	    return (0, _possibleConstructorReturn3.default)(this, (ReviewReply.__proto__ || (0, _getPrototypeOf2.default)(ReviewReply)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ReviewReply, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          reply = _props.reply,
	          replier = _props.replier;
	
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'reply-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'replier' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'replier-pic' },
	            _react3.default.createElement('img', { src: replier && replier.avatar_image ? (0, _media.path)(replier.avatar_image, 'profileAvatar') : defaultImage, alt: replier && replier.name && replier.name.first + ' ' + replier.name.last })
	          ),
	          _react3.default.createElement(
	            'span',
	            { className: 'replier-user-name', styleName: 'replier-user-name' },
	            replier && replier.name && '' + replier.name.first
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reply-content' },
	          _react3.default.createElement(
	            'p',
	            null,
	            reply.text.split('\n').map(function (line, index) {
	              if (index + 1 < reply.text.split('\n').length) {
	                return [_react3.default.createElement(
	                  'span',
	                  { key: 'text-' + index },
	                  line
	                ), _react3.default.createElement('br', { key: 'break-' + index })];
	              }
	              return _react3.default.createElement(
	                'span',
	                { key: 'text-' + index },
	                line
	              );
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'date' },
	            _react3.default.createElement(
	              'span',
	              null,
	              (0, _momentTimezone2.default)(reply.created_at).format('MMMM DD, YYYY')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ReviewReply;
	}(_react2.Component), _class2.propTypes = {
	  reply: _react2.PropTypes.object,
	  replier: _react2.PropTypes.object
	}, _class2.defaultProps = {
	  reply: {}
	}, _temp)) || _class));
	
	exports.default = ReviewReply;
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ZHReview = __webpack_require__(253);
	
	var _ZHReview2 = _interopRequireDefault(_ZHReview);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ZHReview: {
	    displayName: 'ZHReview'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ZHReview.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ZHReview = _wrapComponent('ZHReview')((_dec = (0, _reactCssModules2.default)(_ZHReview2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ZHReview, _Component);
	
	  function ZHReview() {
	    (0, _classCallCheck3.default)(this, ZHReview);
	    return (0, _possibleConstructorReturn3.default)(this, (ZHReview.__proto__ || (0, _getPrototypeOf2.default)(ZHReview)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ZHReview, [{
	    key: 'render',
	    value: function render() {
	      var review = this.props.review;
	
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'review-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reviewer' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'reviewer-pic' },
	            _react3.default.createElement('img', { src: review.user_id && review.user_id.avatar_image ? (0, _media.path)(review.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: review.user_id.name.first + '\'s avatar' })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'review-content' },
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'reviewer-name' },
	            review.user_id && review.user_id.name && review.user_id.name.first + ' ' + review.user_id.name.last
	          ),
	          _react3.default.createElement(
	            'p',
	            { styleName: 'review-p' },
	            review.text
	          )
	        )
	      );
	    }
	  }]);
	  return ZHReview;
	}(_react2.Component), _class2.propTypes = {
	  review: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = ZHReview;
	module.exports = exports['default'];

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(173);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(407));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(173);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(247));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(173);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(247));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex-row":"_1FnM3mJkAWgpztL1qZkj2r","verification-container":"_3J1CwS9q4ZmjCgGw4dZciQ","flex-verification":"_1BaeaZKzNuel3z6vuAPk_9","verification-column":"_9Yf98FIIP9pmvYTphkIEh","text":"_1fluPRrvon82vwQjkamH15","add-text":"_3b8h2cR6zZCUNHdau1cPEy","icon-template":"_1X68LVfuqEvH8lyKTLy8eR","phone-icon-verified":"Xo6EAVIu9pcgKSGOHUKC3 _1X68LVfuqEvH8lyKTLy8eR","phone-icon":"_2m0nsBn_67Alnwegjj4RfV _1X68LVfuqEvH8lyKTLy8eR","email-icon-verified":"uRIWJqifPJBPOY3-cS5nW _1X68LVfuqEvH8lyKTLy8eR","email-icon":"_27Cqagixk_DmwCTIwUx8C5 _1X68LVfuqEvH8lyKTLy8eR","id-icon-verified":"_3cB28nyo4XNbILL07xq7Cr _1X68LVfuqEvH8lyKTLy8eR","id-icon":"_3M0NW6HB5cScHnqKqAuWu5 _1X68LVfuqEvH8lyKTLy8eR","social-icon-verified":"_2QvBO5hpxOvJvmZVdu4FAV _1X68LVfuqEvH8lyKTLy8eR","social-icon":"_2tPnhOyFimx2NHCsZizvoC _1X68LVfuqEvH8lyKTLy8eR","icon-box":"GXe2dNZnHx8vPp716V5TR","verify-template":"KoRHQExVaODNcCOQcciTl","verify-phone":"_3MLwB_VfMSvHRFnAegVqi- KoRHQExVaODNcCOQcciTl","verify-id":"_129E34BChXfxfz_HcPGAG7 KoRHQExVaODNcCOQcciTl","verify-email":"_3kmDO0RRPR3i2K6n5pWL0m KoRHQExVaODNcCOQcciTl","verify-social":"QQJgyOwR0-mZfTaZNpZdS KoRHQExVaODNcCOQcciTl"};

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gray-bg":"_10F1IVPp2ku8OIuuu1TS5b","inner":"_1vYhIqRFJgJdqDdus33z4A _41i8Pp6PmcXzDbgWssrnp","reviews-header":"_1uNV8jl_a1F48ykdZvHQ0i","no-review-header":"GawCKSudw2fxrezso6CEj _1uNV8jl_a1F48ykdZvHQ0i","reviews-filter":"_3jQMzZTdBDrB2XKAa3Okk6 _13UyNN6lRQaIE4nGDzE2-d","reviews-container":"TaojeO2GkHWH_Huq3DGcn","no-review":"_3mF_bRcuEYDWxHWRTngkyU","no-review-icon":"_2z6dckT3-ZqgmqQa6Gc_S2","load-more":"_2RNK2HFF8l6e07k79ucU2A OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","center":"_1wDb-5Yqdq4ZtBzUQ5PUg6","circle":"_3YOxDpC77Si554SLwD2hHn","circle-1":"_3dVTxCez1Z1fdO2B4De8XA _3YOxDpC77Si554SLwD2hHn","circle-2":"_3EdtxjUT_9EkC8ilRZzfYl _3YOxDpC77Si554SLwD2hHn","circle-3":"_1kGuohgObT51IFiDBJXvHJ _3YOxDpC77Si554SLwD2hHn","circle-4":"_3MMr2NcVN2d_BWCZWfi4-0 _3YOxDpC77Si554SLwD2hHn","circle-5":"_1uMUXxVgjFP9rlzkyBPK5u _3YOxDpC77Si554SLwD2hHn","circle-6":"_1SGgPvDfekMZl9hLIgbPwp _3YOxDpC77Si554SLwD2hHn","wo":"MrJiXR_o7a5mRcjOMBDW9"};

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9768ba13770b5b3ce9a749893d493464.jpg";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00b7d6b298ad30005f0513fffe4fc1df.jpg";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e6f06c28c8f6f9d1dae87fbce3af7fa.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54a94f7bcc21d6265fe71cdc94843043.jpg";

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "578b3fe07e3c83dc947429bcb337fee7.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _VerifyStatus = __webpack_require__(420);
	
	var _VerifyStatus2 = _interopRequireDefault(_VerifyStatus);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  VerifyStatus: {
	    displayName: 'VerifyStatus'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/LocalExpertProfile/VerifyStatus.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var VerifyStatus = _wrapComponent('VerifyStatus')((_dec = (0, _reactCssModules2.default)(_VerifyStatus2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(VerifyStatus, _Component);
	
	  function VerifyStatus() {
	    (0, _classCallCheck3.default)(this, VerifyStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (VerifyStatus.__proto__ || (0, _getPrototypeOf2.default)(VerifyStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VerifyStatus, [{
	    key: 'render',
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'div',
	          { styleName: 'flex-row' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'verification-container' },
	            _react3.default.createElement(
	              'h3',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.header' })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'flex-verification' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'verification-column' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'icon-box' },
	              _react3.default.createElement(
	                'div',
	                { styleName: this.props.mobileVerified ? 'phone-icon-verified' : 'phone-icon' },
	                this.props.mobileVerified && _react3.default.createElement('div', { styleName: 'verify-phone' })
	              ),
	              this.props.isOwner && !this.props.mobileVerified ? _react3.default.createElement(
	                _Link2.default,
	                { to: '/dashboard/verification' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'add-text' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.phone_number' })
	                )
	              ) : _react3.default.createElement(
	                'p',
	                { styleName: 'text' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.phone_number' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'icon-box' },
	              _react3.default.createElement(
	                'div',
	                { styleName: this.props.idCardVerified ? 'id-icon-verified' : 'id-icon' },
	                this.props.idCardVerified && _react3.default.createElement('div', { styleName: 'verify-id' })
	              ),
	              this.props.isOwner && !this.props.idCardVerified ? _react3.default.createElement(
	                _Link2.default,
	                { to: '/dashboard/verification' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'add-text' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.id_card' })
	                )
	              ) : _react3.default.createElement(
	                'p',
	                { styleName: 'text' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.id_card' })
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'verification-column' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'icon-box' },
	              _react3.default.createElement(
	                'div',
	                { styleName: this.props.emailVerified ? 'email-icon-verified' : 'email-icon' },
	                this.props.emailVerified && _react3.default.createElement('div', { styleName: 'verify-email' })
	              ),
	              this.props.isOwner && !this.props.emailVerified ? _react3.default.createElement(
	                _Link2.default,
	                { to: '/dashboard/verification' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'add-text' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.email' })
	                )
	              ) : _react3.default.createElement(
	                'p',
	                { styleName: 'text' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.email' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'icon-box' },
	              _react3.default.createElement(
	                'div',
	                { styleName: this.props.socialVerified ? 'social-icon-verified' : 'social-icon' },
	                this.props.socialVerified && _react3.default.createElement('div', { styleName: 'verify-social' })
	              ),
	              this.props.isOwner && !this.props.socialVerified ? _react3.default.createElement(
	                _Link2.default,
	                { to: '/dashboard/profile' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'add-text' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.social' })
	                )
	              ) : _react3.default.createElement(
	                'p',
	                { styleName: 'text' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.social' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return VerifyStatus;
	}(_react2.Component), _class2.propTypes = {
	  mobileVerified: _react2.PropTypes.bool,
	  idCardVerified: _react2.PropTypes.bool,
	  emailVerified: _react2.PropTypes.bool,
	  socialVerified: _react2.PropTypes.bool,
	  isOwner: _react2.PropTypes.bool
	}, _class2.defaultProps = {
	  mobileVerified: false,
	  idCardVerified: false,
	  emailVerified: false,
	  socialVerified: false,
	  isOwner: false
	}, _temp)) || _class));
	
	exports.default = VerifyStatus;
	module.exports = exports['default'];

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(502);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Reviews = __webpack_require__(428);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _Review = __webpack_require__(262);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Reviews: {
	    displayName: 'Reviews'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/Reviews.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	// import RadioReview from './RadioReview';
	var img1 = __webpack_require__(48);
	var img2 = __webpack_require__(433);
	var img3 = __webpack_require__(434);
	var img4 = __webpack_require__(435);
	var img5 = __webpack_require__(436);
	var img6 = __webpack_require__(437);
	
	var Reviews = _wrapComponent('Reviews')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.session.user
	  };
	}, {}), _dec2 = (0, _reactCssModules2.default)(_Reviews2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Reviews, _Component);
	
	  function Reviews(props) {
	    (0, _classCallCheck3.default)(this, Reviews);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Reviews.__proto__ || (0, _getPrototypeOf2.default)(Reviews)).call(this, props));
	
	    _this.loadmore = _this.loadmore.bind(_this);
	
	    if (!(typeof _this.loadmore === 'function')) {
	      throw new TypeError('Value of "this.loadmore" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.loadmore));
	    }
	
	    _this.state = {
	      reviewType: 'recent',
	      show: 3
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Reviews, [{
	    key: 'onChange',
	    value: function onChange(type) {
	      this.setState({ reviewType: type });
	    }
	  }, {
	    key: 'loadmore',
	    value: function loadmore() {
	      this.setState({ show: this.state.show + 3 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var show = this.state.show;
	      var _props = this.props,
	          user = _props.user,
	          reviews = _props.reviews,
	          woReview = _props.woReview,
	          lxName = _props.lxName;
	
	      var count = reviews.length + woReview;
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'div',
	          { styleName: 'gray-bg' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'inner' },
	            _react3.default.createElement(
	              'div',
	              { styleName: count > 0 ? 'reviews-header' : 'no-review-header' },
	              _react3.default.createElement(
	                'h2',
	                null,
	                'Booking & Review'
	              ),
	              count > 0 ? _react3.default.createElement(
	                'span',
	                null,
	                '\xA0',
	                '(',
	                count,
	                ')'
	              ) : _react3.default.createElement(
	                'span',
	                null,
	                '\xA0'
	              )
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner' },
	          count > 0 ? _react3.default.createElement(
	            'div',
	            { styleName: 'reviews-container' },
	            _react3.default.createElement(
	              _reactAddonsCssTransitionGroup2.default,
	              {
	                transitionName: 'modal-transition',
	                transitionEnterTimeout: 200,
	                transitionLeaveTimeout: 200
	              },
	
	              // this.props.reviews.filter((obj)=> {
	              //   if (reviewType === 'positive') {
	              //     if (obj.score >= 4) {
	              //       return true;
	              //     }
	              //     return false;
	              //   } else if (reviewType === 'negative') {
	              //     if (obj.score <= 2) {
	              //       return true;
	              //     }
	              //     return false;
	              //   }
	              //   return true;
	              // })
	              this.props.reviews.map(function (review, index) {
	                if (index < show) {
	                  return _react3.default.createElement(_Review2.default, { key: review._id, review: review, user: user });
	                }
	                return null;
	              })
	            ),
	            woReview > 0 && _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement(
	                'div',
	                { styleName: 'center' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-1' },
	                  _react3.default.createElement('img', { src: img1, alt: '1st traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-2' },
	                  _react3.default.createElement('img', { src: img2, alt: '2nd traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-3' },
	                  _react3.default.createElement('img', { src: img3, alt: '3rd traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-4' },
	                  _react3.default.createElement('img', { src: img4, alt: '4th traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-5' },
	                  _react3.default.createElement('img', { src: img5, alt: '5th traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-6' },
	                  _react3.default.createElement('img', { src: img6, alt: '6th traveler' })
	                )
	              ),
	              _react3.default.createElement(
	                'h3',
	                { styleName: 'wo' },
	                '+ ',
	                woReview,
	                ' more travelers have enjoyed the local experience with ',
	                lxName
	              )
	            ),
	            show < this.props.reviews.length && _react3.default.createElement(
	              'a',
	              { styleName: 'load-more', onClick: this.loadmore },
	              'Load more'
	            )
	          ) : _react3.default.createElement(
	            'div',
	            { styleName: 'no-review' },
	            _react3.default.createElement('div', { styleName: 'no-review-icon' }),
	            _react3.default.createElement(
	              'p',
	              null,
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.reviews.no_review', values: { lineBreak: _react3.default.createElement('br', null), name: lxName } })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Reviews;
	}(_react2.Component), _class2.propTypes = {
	  woReview: _react2.PropTypes.number,
	  lxName: _react2.PropTypes.string,
	  user: _react2.PropTypes.object,
	  reviews: _react2.PropTypes.array
	}, _class2.defaultProps = {
	  woReview: 0,
	  reviews: []
	}, _temp)) || _class) || _class));
	
	exports.default = Reviews;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Product: {
	    displayName: "Product"
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: "/home/runner/work/redux-frontend/redux-frontend/src/components/StructuredData/Product.js",
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Product = _wrapComponent("Product")((_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Product, _Component);
	
	  function Product() {
	    (0, _classCallCheck3.default)(this, Product);
	    return (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Product, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          ratingValue = _props.ratingValue,
	          reviewCount = _props.reviewCount,
	          price = _props.price;
	
	      return _react3.default.createElement(
	        "div",
	        { itemScope: true, itemType: "http://schema.org/Product" },
	        _react3.default.createElement("div", { itemProp: "name", content: name }),
	        (reviewCount || 0) > 0 && _react3.default.createElement(
	          "div",
	          { itemScope: true, itemProp: "aggregateRating", itemType: "http://schema.org/AggregateRating" },
	          _react3.default.createElement("meta", { itemProp: "ratingValue", content: ratingValue || 0 }),
	          _react3.default.createElement("meta", { itemProp: "reviewCount", content: reviewCount || 0 })
	        ),
	        price && _react3.default.createElement(
	          "div",
	          { itemScope: true, itemProp: "offers", itemType: "http://schema.org/Offer" },
	          _react3.default.createElement("meta", { itemProp: "priceCurrency", content: "THB" }),
	          _react3.default.createElement("meta", { itemProp: "price", content: price })
	        )
	      );
	    }
	  }]);
	  return Product;
	}(_react2.Component), _class.propTypes = {
	  name: _react2.PropTypes.string,
	  ratingValue: _react2.PropTypes.number,
	  reviewCount: _react2.PropTypes.number,
	  price: _react2.PropTypes.number
	}, _temp));
	
	exports.default = Product;
	module.exports = exports["default"];

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(544);


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(546);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(545);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(406);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(408);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(410);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(409);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(57);
	
	var _PropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(359);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(554);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 554:
148,

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp2;
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _LocalExpertProfile = __webpack_require__(1270);
	
	var _LocalExpertProfile2 = _interopRequireDefault(_LocalExpertProfile);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactScroll = __webpack_require__(82);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxAsyncConnect = __webpack_require__(34);
	
	var _lxprofile = __webpack_require__(684);
	
	var lxProfileAction = _interopRequireWildcard(_lxprofile);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _VerifyStatus = __webpack_require__(461);
	
	var _VerifyStatus2 = _interopRequireDefault(_VerifyStatus);
	
	var _LocalExpertTrips = __webpack_require__(1561);
	
	var _LocalExpertTrips2 = _interopRequireDefault(_LocalExpertTrips);
	
	var _Reviews = __webpack_require__(473);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _Modal = __webpack_require__(55);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Product = __webpack_require__(474);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Breadcrumbs = __webpack_require__(63);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _helpers = __webpack_require__(19);
	
	var _media = __webpack_require__(21);
	
	var _calendar = __webpack_require__(155);
	
	var _initialLoadSuccess = __webpack_require__(98);
	
	var _redirect = __webpack_require__(326);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  LocalExpertProfile: {
	    displayName: 'LocalExpertProfile'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/LocalExpertProfile/LocalExpertProfile.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ScrollLink = _reactScroll2.default.Link;
	var Element = _reactScroll2.default.Element;
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var LocalExpertProfile = _wrapComponent('LocalExpertProfile')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState,
	        slug = _ref.params.slug;
	
	    if (!(0, _lxprofile.isLoaded)(getState())) {
	      return dispatch((0, _lxprofile.load)(slug)).then(function (res) {
	        if (res.is_redirect) {
	          return dispatch((0, _redirect.setRedirectedPath)('/local-expert/' + res.slug));
	        }
	      }).catch(function () {
	        return dispatch((0, _initialLoadSuccess.loadFailed)());
	      });
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    lxprofile: state.lxprofile.data,
	    error: state.lxprofile.error,
	    loading: state.lxprofile.loading,
	    locale: state.language.locale
	    // locale: state.language.locale,
	  };
	}, lxProfileAction), _dec3 = (0, _reactCssModules2.default)(_LocalExpertProfile2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(LocalExpertProfile, _Component);
	
	  function LocalExpertProfile() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LocalExpertProfile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = LocalExpertProfile.__proto__ || (0, _getPrototypeOf2.default)(LocalExpertProfile)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      isOpenModal: false,
	      openVerifyModal: false
	    }, _this.openModal = function () {
	      _this.setState({ isOpenModal: true });
	    }, _this.closeModal = function () {
	      _this.setState({ isOpenModal: false });
	    }, _this.openVerifyModal = function () {
	      _this.setState({ openVerifyModal: true });
	    }, _this.closeVerifyModal = function () {
	      _this.setState({ openVerifyModal: false });
	    }, _this.checkFaq = function () {
	      var lxprofile = _this.props.lxprofile;
	
	      var check = false;
	      lxprofile.faqs.map(function (f) {
	        if (f.question && f.answer) {
	          check = true;
	        }
	      });
	      return check;
	    }, _this.isVerified = function () {
	      var lxprofile = _this.props.lxprofile;
	
	      var count = 0;
	      if (lxprofile && lxprofile.verification) {
	        if (lxprofile.verification.mobile_verified) {
	          count += 1;
	        }
	        if (lxprofile.verification.id_card_verified) {
	          count += 1;
	        }
	        if (lxprofile.verification.email_verified) {
	          count += 1;
	        }
	        if (lxprofile.verification.facebook_verified) {
	          count += 1;
	        }
	      }
	      if (count >= 2) {
	        return true;
	      }
	      return false;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LocalExpertProfile, [{
	    key: 'render',
	    value: function render() {
	      // const badgeVerifyImage = require('theme/images/icons/badge-verify.png');
	      var defaultImage = __webpack_require__(48);
	      // const {lxprofile, locale} = this.props;
	      var _props = this.props,
	          lxprofile = _props.lxprofile,
	          locale = _props.locale;
	
	      var coverImage = lxprofile.trips && lxprofile.trips.length > 0 && lxprofile.trips[0].cover_image || null;
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(_reactHelmet2.default, { title: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last + ' | ',
	          meta: [{ 'property': 'og:image', 'content': coverImage && (0, _media.path)(lxprofile.trips[0].cover_image, 'profileCover') }, { 'property': 'og:description', 'content': lxprofile.profile && lxprofile.profile.about_me }, { 'property': 'og:site_name', 'content': 'TakeMeTour - ' + (lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last) }, { 'property': 'description', 'content': lxprofile.profile && lxprofile.profile.about_me }]
	        }),
	        _react3.default.createElement(_Product2.default, {
	          name: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last,
	          ratingValue: lxprofile.rating.average_rating,
	          reviewCount: lxprofile.reviews.length
	        }),
	        _react3.default.createElement(
	          _Modal2.default,
	          { centerVertical: true, isOpen: this.state.isOpenModal, style: { 'maxWidth': '500px', 'padding': '0', 'borderRadius': '0', 'margin': '0 auto' }, onClose: this.closeModal, closeStyle: 'btn-close-absolute', id: 'lx-profile-pic' },
	          _react3.default.createElement('img', { src: (0, _media.path)(lxprofile.avatar_image, 'modalImage'), styleName: 'modal-img', alt: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last })
	        ),
	        _react3.default.createElement(
	          _Modal2.default,
	          { isOpen: this.state.openVerifyModal, onClose: this.closeVerifyModal, centerVertical: true, style: { padding: '0' }, id: 'verify-lx-modal' },
	          _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(
	              'h3',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'verify-modal-content' },
	              _react3.default.createElement(
	                'p',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.tool_tip',
	                  values: { lxName: lxprofile && lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last }
	                })
	              ),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'tooltip-link' },
	                _react3.default.createElement(
	                  'a',
	                  { href: 'https://www.takemetour.com/help-center/traveler?topic=&index=3', target: '_blank' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.learn_more' }),
	                  ' ',
	                  _react3.default.createElement('i', { styleName: 'next-icon' })
	                )
	              )
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'banner', style: coverImage && (0, _media.path)(lxprofile.trips[0].cover_image, 'profileCover', true) },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'banner-content' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'profile-picture' },
	              _react3.default.createElement('img', { src: lxprofile.avatar_image ? (0, _media.path)(lxprofile.avatar_image, 'profileAvatar') : defaultImage, alt: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'profile-bg' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'inner' },
	            _react3.default.createElement(_Breadcrumbs2.default, { type: 'LocalExpertProfile', localExpert: lxprofile, customStyle: { paddingLeft: '25px', marginTop: '-100px', marginBottom: '100px' } }),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'flex-row' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'lx-profile-container' },
	                _react3.default.createElement(
	                  'h1',
	                  null,
	                  lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last
	                ),
	                _react3.default.createElement(
	                  'p',
	                  null,
	                  lxprofile.profile && lxprofile.profile.current_city && lxprofile.profile.current_city + ', ',
	                  lxprofile.last_country || 'Thailand',
	                  _react3.default.createElement('br', { styleName: 'mobile-newline' }),
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'gray-text' },
	                    _react3.default.createElement(
	                      'span',
	                      { styleName: 'divider' },
	                      '|'
	                    ),
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.member_since' }),
	                    ' ',
	                    (0, _momentTimezone2.default)(lxprofile.created_at).format((0, _calendar.getMYFormat)(locale))
	                  )
	                ),
	                lxprofile.response && _react3.default.createElement(
	                  'div',
	                  { styleName: 'response' },
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'response-item' },
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'gray-text' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.response_rate' })
	                    ),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'weight-400' },
	                      (0, _helpers.getResponse)(lxprofile.response).rate
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'response-item' },
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'gray-text' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.response_time' })
	                    ),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'weight-400' },
	                      (0, _helpers.getResponse)(lxprofile.response).time
	                    )
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'verify-row' },
	                  this.isVerified() && [_react3.default.createElement(
	                    'div',
	                    { styleName: 'verify-item-mobile', onClick: this.openVerifyModal, key: 1 },
	                    _react3.default.createElement('div', { styleName: 'verify-icon' }),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'weight-400' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
	                    )
	                  ), _react3.default.createElement(
	                    'div',
	                    { styleName: 'verify-item-desktop', key: 2 },
	                    _react3.default.createElement('div', { styleName: 'verify-icon' }),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'weight-400' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
	                    ),
	                    _react3.default.createElement(
	                      'div',
	                      { styleName: 'tooltip' },
	                      _react3.default.createElement(
	                        'div',
	                        { styleName: 'tooltip-header-container' },
	                        _react3.default.createElement('i', { styleName: 'inspiration-icon' }),
	                        _react3.default.createElement(
	                          'span',
	                          { styleName: 'tooltip-header' },
	                          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
	                        )
	                      ),
	                      _react3.default.createElement(
	                        'p',
	                        { styleName: 'tooltip-content' },
	                        _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.tool_tip',
	                          values: { lxName: lxprofile && lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last }
	                        })
	                      ),
	                      _react3.default.createElement(
	                        'p',
	                        { styleName: 'tooltip-link' },
	                        _react3.default.createElement(
	                          'a',
	                          { href: 'https://www.takemetour.com/help-center/traveler?topic=&index=3', target: '_blank' },
	                          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.learn_more' }),
	                          ' ',
	                          _react3.default.createElement('i', { styleName: 'next-icon' })
	                        )
	                      )
	                    )
	                  )],
	                  lxprofile.verification && lxprofile.verification.has_badge && _react3.default.createElement(
	                    'div',
	                    { styleName: 'verify-item' },
	                    _react3.default.createElement('div', { styleName: 'super-lx-icon' }),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'weight-400' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.super_lx.header' })
	                    )
	                  )
	                ),
	                _react3.default.createElement(
	                  'p',
	                  null,
	                  lxprofile.profile && lxprofile.profile.about_me
	                )
	              )
	            ),
	            lxprofile.rating.count ? _react3.default.createElement(
	              'div',
	              { styleName: 'point-text-container' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'point-container-mobile' },
	                _react3.default.createElement(_RatingPoint2.default, { point: lxprofile.rating.score / lxprofile.rating.count })
	              ),
	              _react3.default.createElement(
	                'h5',
	                { styleName: 'point-text' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'bold' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.rating.overall' }),
	                  ' ',
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'hilight' },
	                    (0, _helpers.getRatingPoint)(lxprofile.rating.score / lxprofile.rating.count)
	                  ),
	                  '/5'
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'point-container-desktop' },
	                  _react3.default.createElement(_RatingPoint2.default, { point: lxprofile.rating.score / lxprofile.rating.count })
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'hilight' },
	                  _react3.default.createElement(
	                    ScrollLink,
	                    { to: 'allReview', smooth: true, offset: -80, duration: 500 },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.all_reviews' })
	                  )
	                )
	              )
	            ) : null,
	            _react3.default.createElement(_VerifyStatus2.default, {
	              mobileVerified: lxprofile.verification && lxprofile.verification.mobile_verified,
	              idCardVerified: lxprofile.verification && lxprofile.verification.id_card_verified,
	              socialVerified: lxprofile.verification && lxprofile.verification.facebook_verified,
	              emailVerified: lxprofile.verification && lxprofile.verification.email_verified
	            })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner' },
	          this.checkFaq() && _react3.default.createElement(
	            'div',
	            { styleName: 'more-info-container' },
	            _react3.default.createElement(
	              'h2',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.more_info' })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'more-info-content' },
	              lxprofile.faqs.map(function (faq, index) {
	                if (faq.question && faq.answer) {
	                  return _react3.default.createElement(
	                    'div',
	                    { styleName: 'more-info-column', key: 'faq-' + index },
	                    _react3.default.createElement(
	                      'h3',
	                      null,
	                      faq.question
	                    ),
	                    _react3.default.createElement(
	                      'p',
	                      null,
	                      faq.answer
	                    )
	                  );
	                }
	              })
	            )
	          ),
	          _react3.default.createElement(_LocalExpertTrips2.default, { lxName: lxprofile.name, trips: lxprofile.trips })
	        ),
	        _react3.default.createElement(Element, { name: 'allReview' }),
	        lxprofile.reviews && lxprofile.reviews.length > 0 && _react3.default.createElement(
	          'div',
	          { styleName: 'reviews-container' },
	          _react3.default.createElement(_Reviews2.default, { reviews: lxprofile.reviews, lxName: lxprofile.name.first, woReview: lxprofile.travelers_without_review })
	        )
	      );
	    }
	  }]);
	  return LocalExpertProfile;
	}(_react2.Component), _class2.propTypes = {
	  lxprofile: _react2.PropTypes.object,
	  error: _react2.PropTypes.string,
	  loading: _react2.PropTypes.bool,
	  load: _react2.PropTypes.func.isRequired,
	  locale: _react2.PropTypes.string
	  // locale: PropTypes.string,
	}, _temp2)) || _class) || _class) || _class));
	
	exports.default = LocalExpertProfile;
	module.exports = exports['default'];

/***/ }),

/***/ 1189:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"trips-container":"_27tTb2rc8l5BrBw5bzE4dh","line":"mLG5Pjwj7BYYizN6iOC69"};

/***/ }),

/***/ 1270:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_3m8icrTNPXTOrpeCJlpXcL _1sIUL8Csti_qoesv1eSx1i","inner":"dAyvU1PVrdxdT-nch8Jre _41i8Pp6PmcXzDbgWssrnp","modal-img":"_2s8r7MWl_xtfN2NfmmJ0oO","profile-bg":"_3btWv6Jk7gBaLtmhoBRE7-","banner":"_2ZrIB3gigtOHTYS56nwkmT","banner-content":"ZgYR5xo7TPLLYB23gA6ju","profile-picture":"_3fxrhYQrpXp4J0rhVHK2xu","badge-verify":"_1hx1DU99vyZS6t4mcWy6Xk","flex-row":"_1QNd9UZWFgN7YgqHG7PpZ8","lx-profile-container":"_3EnL9X0IHpH2-2rkf2XOve","gray-text":"_3Ky6l5XDkVLtvzR6l7s543","weight-400":"thNy02oWnI5V_gzKJt8rA","divider":"LK_F3fTzYemu0gewlqy2J _13UyNN6lRQaIE4nGDzE2-d","response":"_11Z3hzwfixhRnYsfhHC89e","response-item":"_9EBXavnXJgnJay__3a6m5","mobile-newline":"_1BfyL-ARpFdTUHB9bRuwEt _3jblqlydyeJqpKzpSv89pq","verify-row":"_1vMUuTaBkfZKoCeDbdNVaR","verify-item":"_3Uu3wtqnif5hlaKbnmFqHN","tooltip":"v8BsS06CXkd40B6iVDIGe","verify-item-mobile":"_5jDcmBUJgkYUuUugByBzL _3jblqlydyeJqpKzpSv89pq _3Uu3wtqnif5hlaKbnmFqHN","verify-item-desktop":"_3UptHzMJjyDithkRNWCDyY _13UyNN6lRQaIE4nGDzE2-d _3Uu3wtqnif5hlaKbnmFqHN","icon-template":"_2iUd_mdf5jGCdg2bIEWApl","verify-icon":"_35fTt3lhm7k6g6GO5jCSKB _2iUd_mdf5jGCdg2bIEWApl","super-lx-icon":"_3FLF0EZk2psJ-BUYX_jNhm _2iUd_mdf5jGCdg2bIEWApl","tooltip-header-container":"_2-2x1xDzD93oSiGeGDCt2i","inspiration-icon":"_3h-v5Hhwb8FrAkSDFl8ngD","tooltip-header":"_3ng7rdEqjffvj7jZ2AAsSG","tooltip-content":"_2B5mp1DsKuUs9pa9Z4UjDJ","tooltip-link":"j-QYxhe80rgd7W6tRpOoo","next-icon":"_1o78piRypLUtC2IZQUYvQZ","verify-modal-content":"N4fP0oUYQQXivyYEGy6FM","point-container":"He8Lr4noluiadBoGClAfh","point-container-desktop":"QkeR39wsGrG3rgdpe7DAW He8Lr4noluiadBoGClAfh _13UyNN6lRQaIE4nGDzE2-d","point-container-mobile":"_2xMB8C4JTrlO-DIbYsOPfk He8Lr4noluiadBoGClAfh _3jblqlydyeJqpKzpSv89pq","rating":"_31KTdLTlu4Ei4GrZ_qCNXp","bold":"_29PMX7PTbAimnSIjtHRbvp","point-text-container":"_3jgM-xwGMj403Xr12WezVm","point-text":"G6j-kFkfqWwUKTMNo3zpc","hilight":"_1Wr8njB5ha0d5_zDwfH0CG","more-info-container":"_3-nI6R6EJEBVCXAYbWuSUp","more-info-content":"igS5aQ1BZD38KDoF5ycPH","more-info-column":"_1vfZc7OV28WSACTcE8BYQ7","more-info-hobby-column":"_1EcQP13U_WZA-zL-L3I4sr","more-info-why-column":"_3mE12eh_h_eVVNrK5PgTnu","reviews-container":"_1ZWcRk8pZ9d1D0XLIJqhZ8"};

/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _LocalExpertTrips = __webpack_require__(1189);
	
	var _LocalExpertTrips2 = _interopRequireDefault(_LocalExpertTrips);
	
	var _reactIntl = __webpack_require__(10);
	
	var _Trip = __webpack_require__(112);
	
	var _Trip2 = _interopRequireDefault(_Trip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  LocalExpertTrips: {
	    displayName: 'LocalExpertTrips'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/LocalExpertProfile/LocalExpertTrips.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var LocalExpertTrips = _wrapComponent('LocalExpertTrips')((_dec = (0, _reactCssModules2.default)(_LocalExpertTrips2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(LocalExpertTrips, _Component);
	
	  function LocalExpertTrips() {
	    (0, _classCallCheck3.default)(this, LocalExpertTrips);
	    return (0, _possibleConstructorReturn3.default)(this, (LocalExpertTrips.__proto__ || (0, _getPrototypeOf2.default)(LocalExpertTrips)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LocalExpertTrips, [{
	    key: 'render',
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'trips-container' },
	        _react3.default.createElement(
	          'h2',
	          null,
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.trips.header', values: { lxName: this.props.lxName && this.props.lxName.first + ' ' + this.props.lxName.last } })
	        ),
	        _react3.default.createElement('hr', { styleName: 'line' }),
	        this.props.trips.map(function (trip, index) {
	          return _react3.default.createElement(_Trip2.default, { key: 'trip-' + index, trip: trip });
	        })
	      );
	    }
	  }]);
	  return LocalExpertTrips;
	}(_react2.Component), _class2.propTypes = {
	  lxName: _react2.PropTypes.object,
	  trips: _react2.PropTypes.array
	}, _temp)) || _class));
	
	exports.default = LocalExpertTrips;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// local-expert-854d4bd50b748dd6382d.js